import React from "react";
import ReactDOM from "react-dom";
import DropZone from './components/DropZone.js';

const urlParam = new URLSearchParams(window.location.search)

ReactDOM.render(<DropZone signingUrl={urlParam.get('signingUrl')}
                 folder={urlParam.get('folder')}
                 multiple={urlParam.get('multiple') === 'false'?false:true}
                 confirmUpload={urlParam.get('confirmUrl')}
                  />, document.getElementById('app'));